import React, { ReactElement, SetStateAction, Dispatch } from 'react'
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, Stack } from '@mui/material';

interface Props {
    dialogTitle: string
    children: ReactElement
    openDialog: boolean
    setOpenDialog: Dispatch<SetStateAction<boolean>>
}

function CustomDialog(props: Props): ReactElement {
    return (
        <>
            <Dialog fullWidth maxWidth='md' open={props.openDialog} style={{ height: '100%' }} >
                <Stack direction='row' >
                    <DialogTitle style={{ fontSize: 14, fontWeight: 'bolder', width: '50%' }} > {props.dialogTitle}</DialogTitle>
                    <DialogActions style={{ width: '50%' }}> <Button style={{ marginRight: 20 }} onClick={() => props.setOpenDialog(false)}>Close</Button></DialogActions>
                </Stack>
                <DialogContent>
                    {props.children}
                    <br />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default CustomDialog